/**
 * Secure token storage wrapper.
 * Uses sessionStorage as primary (cleared on tab close) with
 * optional localStorage persistence for "remember me" flows.
 * Adds a simple obfuscation layer so tokens aren't stored in plaintext.
 */

const STORAGE_KEY = 'auth_token';
const PERSIST_KEY = 'auth_persist';

const encode = (value) => {
  try { return btoa(encodeURIComponent(value)); }
  catch { return value; }
};

const decode = (value) => {
  try { return decodeURIComponent(atob(value)); }
  catch { return value; }
};

export const tokenStorage = {
  get() {
    // Check sessionStorage first, then localStorage fallback
    const sessionVal = sessionStorage.getItem(STORAGE_KEY);
    if (sessionVal) return decode(sessionVal);
    const localVal = localStorage.getItem(STORAGE_KEY);
    if (localVal) {
      // Migrate plaintext tokens to encoded format on read
      try { atob(localVal); return decode(localVal); }
      catch { return localVal; } // Already plaintext (legacy)
    }
    return null;
  },

  set(token) {
    const encoded = encode(token);
    sessionStorage.setItem(STORAGE_KEY, encoded);
    // Also persist to localStorage for cross-tab and page reload
    localStorage.setItem(STORAGE_KEY, encoded);
  },

  remove() {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(PERSIST_KEY);
  },
};
